export default __webpack_public_path__ + "static/media/comp-03.78e64fef.svg";